
define('text!views/notsupportedbrowserMobile.html?v=1428580677492',[],function () { return '<section id="notSupportedBrowserMobile" class="not-supported-browser">\r\n    <h2 data-translate-text="[browser not supported]">Your browser is currently not supported.</h2>\r\n</section>';});

